/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `waiting` - Čeká * `in_process` - Probíhá * `finished` - Dokončeno * `incomplete` - Nedokončeno
 */
export type StateEnum = 'waiting' | 'in_process' | 'finished' | 'incomplete';

export const StateEnum = {
    Waiting: 'waiting' as StateEnum,
    InProcess: 'in_process' as StateEnum,
    Finished: 'finished' as StateEnum,
    Incomplete: 'incomplete' as StateEnum
};